import ActionTypes from "../../enums/ActionTypes"

interface State {
  rights: []
}

const initialState: State = {
  rights: [],
}

interface Action {
  type: string
  payload: {
    userRights: object
  }
}


export default (state: State = initialState, action: Action) => {

  switch(action.type) {
    case ActionTypes.USER_RIGHTS_REQUEST:
      return {
        ...initialState,
        isPending: true
      }

    case ActionTypes.USER_RIGHTS_SUCCESS: {
      const { userRights } = action.payload
      return {
        ...state,
        isLoaded: true,
        isPending: false,
        rights: userRights
      }
    }

    default:
      return state
  }
  
}